import { put, takeEvery } from 'redux-saga/effects';
import { forgotPassword } from 'api/signIn';
import { startForgotPasswordSubmit, resolveForgotPasswordSubmit } from './actions';

export function* forgotPasswordSubmitSaga(action: any) {
  try {
    yield forgotPassword(action.payload);
    yield put(resolveForgotPasswordSubmit());
  } catch (error) {
    yield put(resolveForgotPasswordSubmit(error.response));
  }
}

export default function* forgotPasswordSaga() {
  yield takeEvery(startForgotPasswordSubmit, forgotPasswordSubmitSaga);
}
